/* eslint-disable import/prefer-default-export */
export const gtagEvent = (_action, params) => {
  window.gtag('event', _action, params);
};
